
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Panel from 'components/Panel'
import Link from 'components/Link'
import classnames from 'classnames'

export default class UpgradePanel extends React.Component {
  static propTypes = {
    fullWidth: PropTypes.bool
  }

  render() {
    const {children, fullWidth} = this.props
    const classNames = classnames('upgrade-panel', {
      'is-full-width': fullWidth
    })

    return (
      <Panel
        className={classNames}
        custom
        notice
      >
        <div className='upgrade-panel_inner'>
          <div className='upgrade-panel_body'>{children}</div>
          <div className='upgrade-panel_cta'>
            <Link className='button no-borders' to='/settings'>Upgrade Now</Link>
          </div>
        </div>
      </Panel>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/UpgradePanel/index.js